import { FileNode } from './FileNode';
import { FolderNode } from './FolderNode';
export function TreeNode(props) {
    const { item, isLastItem } = props;
    if (item.previewType === 'folder') {
        return <FolderNode {...item} isLastItem={isLastItem}/>;
    }
    return <FileNode {...item}/>;
}
